
















import { Component, Vue, Mixins } from 'vue-property-decorator'; // 반드시 Vue를 vue-property-decorator에 있는 것을 써야함
import VueHoduCommon from '@/mixin/VueHoduCommon';

import { namespace } from 'vuex-class';
const WareInfo = namespace('WareInfo');

@Component({
    components: {
        
    },
})
export default class Popup extends Mixins(VueHoduCommon) {

    /**
     * @WareInfo.State
     */
    @WareInfo.State show_voucher_modal !: boolean;

    /**
     * @WareInfo.Action
     */
    @WareInfo.Action doSetShowVoucherModal ?: (params : boolean) => void;

    mounted() {
        
    }

    isModalOpen() : boolean {
        return this.show_voucher_modal;
    }

    goVoucher() : void {
        window.open("/voucher.html", "_blank");
    }

    voucherClose() : void {
        if( this.doSetShowVoucherModal ) this.doSetShowVoucherModal(false);
    }

    voucherNotViewToday() : void {
        const today = new Date();
        const today_key = `${today.getFullYear()}${`0${today.getMonth() + 1}`.slice(-2)}${`0${today.getDate()}`.slice(-2)}`;
        localStorage.setItem('voucher_not_view_today', today_key);

        this.voucherClose();
    }

}
